import { CurrencyPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, computed } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { PairLogoComponent } from '@components/pair-logo/pair-logo.component';
import { SideCardComponent } from '@components/side-card/side-card.component';
import { BASE_TOKENS } from '@constants/chain.constants';
import { WalletLgeData } from '@models/presale.model';
import { BalanceObject } from '@models/token.model';
import { FormatPipe } from '@pipes/format.pipe';
import { ModalService } from '@services/modal-service.service';
import { WagmiService } from '@services/wagmi.service';
import { WalletService } from '@services/wallet.service';
import { chainId, wallet } from '@stores/chain.store';
import { SafeBig } from '@utils/numbers.util';

@Component({
  selector: 'cmp-token-info-list',
  templateUrl: './token-info-list.component.html',
  styles: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe, PairLogoComponent, FormatPipe, ButtonComponent, SideCardComponent, NgClass],
})
export class TokenInfoListComponent {
  @HostBinding('class') class = ['token-info-list'];

  get walletBalance() {
    return this.walletService.walletSdBalances;
  }

  get stakeBalance() {
    return this.walletService.sdStakeBalanceItems;
  }

  get walletLges() {
    return this.walletService.walletLgeBalances;
  }

  get wallet() {
    return wallet;
  }

  baseToken = computed(() => BASE_TOKENS[chainId()]);

  totalWalletValue = computed(() => (wallet() ? this.walletBalance()?.reduce((prev, curr) => SafeBig(prev).add(curr.walletValueUSD).toString(), '0') : '0'));
  totalStakeValue = computed(() => (wallet() ? this.stakeBalance()?.reduce((prev, curr) => SafeBig(prev).add(curr.stakeValueUSD).toString(), '0') : 0));

  totalLgeValue = computed(() =>
    wallet()
      ? this.walletLges()?.reduce(
          (prev, { shareUsdValues: { total, totalClaimable } }) => ({
            total: SafeBig(prev.total).add(SafeBig(total)).toString(),
            claimable: SafeBig(prev.claimable).add(SafeBig(totalClaimable)).toString(),
          }),
          {
            total: '0',
            claimable: '0',
          },
        )
      : {
          total: '0',
          claimable: '0',
        },
  );

  constructor(
    private wagmiService: WagmiService,
    private modalService: ModalService,
    private walletService: WalletService,
  ) {}

  openTokenPreview({ token }: BalanceObject) {
    this.modalService.openTokenPreview(token?.address);
  }

  openLge(item: WalletLgeData) {
    this.modalService.openPresale(item.address);
  }

  connectWallet() {
    this.wagmiService.connectWallet();
  }
}
